module.exports = __webpack_public_path__ + "static/media/arch.f91f5197.png";